import axios from "axios";

export default {
	voidLabel(ctx, payload) {
		console.log(payload);
	},
};
